import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import ApiRequest from "../../helper/ApiRequest";
import CustomImageUpload from "../../component/CustomImageUpload";
import DynamicCKEditor from "../../component/DynamicCkEditor";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";
import CustomSelect from "../../component/CustomSelect";

const categoryListEndpoint=ApiEndpoints.caseCategory.caseCategoryList;
const caseStudyCreate = ApiEndpoints.caseStudy.caseStudyCreate;
export default function CaseCreate() {
  const navigate = useNavigate();
   const [categories, setCategories] = useState([]);
  const [previews, setPreviews] = useState({ thumbnail_image: null,  banner_image: null,  casestudy_logo: null,  key_challenges_banner_image: null,  key_implementations_image: null, results_image: null, });
 const [postData, setPostData] = useState({
    title: "",
    slug: "",
    casestudycategory_id: "",
    state: "",
    featured: "",
    status: "0",
    thumbnail_image: "",
    alt_thumbnail: "",
    banner_image: "",
    alt_banner_image: "",
    casestudy_logo: "",
    alt_casestudy_logo: "",
    short_description: "",
    introduction: "",
    key_challenges: "",
    key_challenges_banner_image: "",
    alt_key_challenges_banner_image: "",
    the_solution: "",
    key_implementations: "",
    key_implementations_image: "",
    alt_key_implementations_image: "",
    results: "",
    results_image: "",
    alt_results_image: "",
  });


 const dataFetch = async () => {
      try {
        const response = await ApiRequest("GET", categoryListEndpoint);
        const result = response.casestudy_categories;
        setCategories(result);
      } catch (error) {
        console.log(error);
      }
    };

  useEffect(() => {
    dataFetch();
  }, []);


  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (files) {
      const file = files[0];
      // Update the previews state
      setPreviews((prev) => ({
        ...prev,
        [name]: URL.createObjectURL(file),
      }));

      // Update the postData state
      setPostData((prev) => ({
        ...prev,
        [name]: file,
      }));
    } else {
      setPostData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };


  const handleEditorChange = (key, data) => {
    setPostData((prevState) => ({
      ...prevState,
      [key]: data,
    }));
  };


  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    for (const [key, value] of Object.entries(postData)) {
      if (key !== "brief" && (value === "" || value === null)) {
        toast.error(`The field "${key}" is mandatory.`);
        return;
      }
    }

    const formData = new FormData();
    Object.entries(postData).forEach(([key, value]) => {
      formData.append(key, value);
    });

    try {
      const response = await ApiRequest("POST", caseStudyCreate, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success(response.casestudys);
      navigate("/case");
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const pagename = {
    name: 'Case Management',
    user: 'Admin',
    innerpage: 'Case Management / Case / Add Case'
  }

  const states = [
  { _id: "Andhra Pradesh", name: "Andhra Pradesh" },
  { _id: "Arunachal Pradesh", name: "Arunachal Pradesh" },
  { _id: "Assam", name: "Assam" },
  { _id: "Bihar", name: "Bihar" },
  { _id: "Chhattisgarh", name: "Chhattisgarh" },
  { _id: "Goa", name: "Goa" },
  { _id: "Gujarat", name: "Gujarat" },
  { _id: "Haryana", name: "Haryana" },
  { _id: "Himachal Pradesh", name: "Himachal Pradesh" },
  { _id: "Jammu and Kashmir", name: "Jammu and Kashmir" },
  { _id: "Jharkhand", name: "Jharkhand" },
  { _id: "Karnataka", name: "Karnataka" },
  { _id: "Kerala", name: "Kerala" },
  { _id: "Madhya Pradesh", name: "Madhya Pradesh" },
  { _id: "Maharashtra", name: "Maharashtra" },
  { _id: "Manipur", name: "Manipur" },
  { _id: "Meghalaya", name: "Meghalaya" },
  { _id: "Mizoram", name: "Mizoram" },
  { _id: "Nagaland", name: "Nagaland" },
  { _id: "Odisha", name: "Odisha" },
  { _id: "Punjab", name: "Punjab" },
  { _id: "Rajasthan", name: "Rajasthan" },
  { _id: "Sikkim", name: "Sikkim" },
  { _id: "Tamil Nadu", name: "Tamil Nadu" },
  { _id: "Telangana", name: "Telangana" },
  { _id: "Tripura", name: "Tripura" },
  { _id: "Uttarakhand", name: "Uttarakhand" },
  { _id: "Uttar Pradesh", name: "Uttar Pradesh" },
  { _id: "West Bengal", name: "West Bengal" },
  { _id: "Andaman and Nicobar Islands", name: "Andaman and Nicobar Islands" },
  { _id: "Chandigarh", name: "Chandigarh" },
  { _id: "Dadra and Nagar Haveli", name: "Dadra and Nagar Haveli" },
  { _id: "Daman and Diu", name: "Daman and Diu" },
  { _id: "Delhi", name: "Delhi" },
  { _id: "Lakshadweep", name: "Lakshadweep" },
  { _id: "Puducherry", name: "Puducherry" }
];



  return (
    <>
      <AdminHeader pagename={pagename} />
      <div className="add-content-page">
        <form id="caseAdd" onSubmit={handleSubmit}>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>title<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="title" type="text" className="form-control" placeholder="Enter Title" />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>slug<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="slug" type="text" className="form-control" placeholder="Enter Slug" />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Select Cetegory:<small>*</small></label>
                  </div>
                  <CustomSelect onChange={handleChange} name="casestudycategory_id"  options={categories} placeholder="Select Category" />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Select State:<small>*</small></label>
                  </div>
                  <CustomSelect onChange={handleChange}  name="state"  options={states} placeholder="Select Category" />
                </div>
              </div>

              <div class="col-md-6 case-radio-option ">
                <div className="row">
                  <div className="col-lg-3">
                    <div className="add-page-inputs input-add-image">
                      <div className="label-wrap-add">
                        <label>Featured:<small>*</small></label>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-9">
                    <div className="add-page-inputs input-add-image">
                       <div className="add-page-inputs input-add-image">
                      <input type="radio" id="positive" name="featured" value="1"     onChange={handleChange} style={{ height:"auto",  marginRight: "5px" }} />
                      <label htmlFor="positive" style={{ marginRight: "20px" }}>Yes</label>
                      <input type="radio" id="negative" name="featured" value="0" onChange={handleChange}  defaultChecked style={{  height:"auto",  marginRight: "5px" }} />
                      <label htmlFor="negative">No</label>
                    </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6 case-radio-option ">
                <div className="row">
                  <div className="col-md-2">
                    <div className="label-wrap-add add-page-inputs ">
                      <label>Status:</label>
                    </div>
                  </div>
                  <div className="col-md-10">
                    <div className="add-page-inputs input-add-image">
                      <input type="radio" id="active" name="status" value="1" onChange={handleChange} style={{ height:"auto" , marginRight: "5px" }} />
                      <label htmlFor="active" style={{ marginRight: "20px" }}>Active</label>
                      <input type="radio" id="inactive" name="status" value="0" defaultChecked onChange={handleChange} style={{ height:"auto",   marginRight: "5px" }} />
                      <label htmlFor="inactive">Inactive</label>
                    </div>
                  </div>
                </div>
              </div>


            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-4">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Thumbnail Image (716 × 424)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="thumbnail_image"
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.thumbnail_image} />
                </div>
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Alt Thumbnail Image:<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="alt_thumbnail" type="text" className="form-control" placeholder="Alt Thumbnail Image" />
                </div>
              </div>

              <div className="col-lg-4">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Media Logo (	168 × 42):*<small>*</small></label>
                  </div>
                  <CustomImageUpload name="casestudy_logo"
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.casestudy_logo}
                  />
                </div>
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Alt Media Logo:<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="alt_casestudy_logo" type="text" className="form-control" placeholder="Alt Media Image" />
                </div>
              </div>

              <div className="col-lg-4">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Banner Image  (1920 × 660 ) <small>*</small></label>
                  </div>
                  <CustomImageUpload name="banner_image"
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.banner_image}
                  />
                </div>
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Alt Banner Image:<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="alt_banner_image" type="text" className="form-control" placeholder="Alt Banner Image" />
                
                </div>
              </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Short Description<small>*</small></label>
                  </div>
                      <input onChange={handleChange} name="short_description" type="text" className="form-control" placeholder="Short Description" />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Introduction:<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.introduction} onChange={(event, editor) =>
                    handleEditorChange("introduction", editor.getData())} />
                </div>
              </div>
            </div>
          </div>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Key Challenges:<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.key_challenges} onChange={(event, editor) =>
                    handleEditorChange("key_challenges", editor.getData())} />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>key challenges Image (1920 × 660 px):<small>*</small></label>
                  </div>
                  <CustomImageUpload name="key_challenges_banner_image"
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.key_challenges_banner_image}
                  />
                </div>
              </div>

              <div className="col-lg-12">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Alt key challenges Image<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="alt_key_challenges_banner_image" type="text" className="form-control" placeholder="Alt Key Challenges Image" />
                </div>
              </div>

            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Solutions:<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.the_solution} onChange={(event, editor) =>
                    handleEditorChange("the_solution", editor.getData())} />
                </div>
              </div>
            </div>
          </div>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Key Implementations:<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.key_implementations} onChange={(event, editor) =>
                    handleEditorChange("key_implementations", editor.getData())} />
                </div>
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Key Implementations Image (1245 × 480):<small>*</small></label>
                  </div>
                  <CustomImageUpload name="key_implementations_image"
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.key_implementations_image}
                  />
                </div>
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Alt Key Implementations Image<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="alt_key_implementations_image" type="text" className="form-control" placeholder="Alt Key Implementations Image" />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Results<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.results} onChange={(event, editor) =>
                    handleEditorChange("results", editor.getData())} />
                </div>
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Results Image (1245 × 480 px)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="results_image"
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.results_image}
                  />
                </div>
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Alt Results Image<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="alt_results_image" type="text" className="form-control" placeholder="Alt Results Image" />
                </div>
              </div>
            </div>
          </div>

        </form>
        <button type="submit" form="caseAdd" className="default-btn">publish <span></span></button>
      </div>
    </>
  );
}
